import { lazy, Suspense, useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import { trackViewContent } from "@/hooks/useAnalytics";

// Lazy load below-the-fold components to reduce initial bundle size
const HowItWorks = lazy(() => import("@/components/HowItWorks"));
const SixClauses = lazy(() => import("@/components/SixClauses"));
const TrustPrivacy = lazy(() => import("@/components/TrustPrivacy"));
const Pricing = lazy(() => import("@/components/Pricing"));
const CTA = lazy(() => import("@/components/CTA"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  useEffect(() => {
    trackViewContent("Homepage");
  }, []);
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>RentSense NL – AI Dutch Rental Contract Analyzer for Expats</title>
        <meta name="description" content="Understand your Dutch rental contract before signing. AI-assisted analysis built with reference to official Dutch government and Huurcommissie information." />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="RentSense NL – AI Dutch Rental Contract Analyzer" />
        <meta property="og:description" content="Upload your Dutch rental contract and get a clear analysis of risky clauses in plain English. Built for expats and international students." />
        <meta property="og:url" content="https://www.rentsense.nl" />
        <meta property="og:image" content="https://www.rentsense.nl/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="RentSense NL – AI Rental Contract Analyzer for Tenants" />
        <meta name="twitter:description" content="Upload your Dutch rental contract and get a clear analysis of risky clauses in plain English. Built for expats." />
        <meta name="twitter:image" content="https://www.rentsense.nl/og-image.png" />
      </Helmet>
      
      <Header />
      <main>
        <Hero />
        <Suspense fallback={null}>
          <HowItWorks />
          <SixClauses />
          <TrustPrivacy />
          <Pricing />
          <CTA />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
